import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=aa2d293c&lang=pug&"
import script from "./edit.vue?vue&type=script&lang=coffee&"
export * from "./edit.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./edit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports